<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_ACCOUNT_CONFIRMATION"
    :handler="() => $refs.modal.show()"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.BOOKMAKER_ID_CONFIRMED"
    :handler="() => $refs.modal.hide('confirmed_action')"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent
    ref="modal"
    type="modal"
    mainClass="fixed z-[61]"
    @closed="
      ({ source }) =>
        source !== 'confirmed_action' &&
        $bus.emit(
          $constants.EVENTS.BOOKMAKER.BOOKMAKER_ID_CONFIRMATION_CANCELED
        )
    "
  >
    <div class="py-2"></div>
    <div
      v-if="
        $stores.bookmaker?.state?.bookmakerData?.[
          `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
        ]?.error
      "
    >
      <div class="text-xl font-bold mb-5">
        Erreur de vérification de votre compte
        {{ $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerName }}
      </div>
      <span class="text-red-500">
        {{
          $stores.bookmaker?.state?.bookmakerData?.[
            `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
          ]?.error
        }}
      </span>
    </div>
    <div
      v-else-if="
        $stores.bookmaker?.state?.bookmakerData?.[
          `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
        ]?.data
      "
      class=""
    >
      <div class="text-xl font-bold mb-5">
        Confirmez votre compte
        {{ $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerName }}
      </div>
      <span class="text-green-500 text-lg">
        Nous allons utiliser votre comtpte
        {{
          $stores.bookmaker?.state?.bookmakerData?.[
            `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
          ]?.data?.name
        }}
        ({{ $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId }}).
        Voulez vous continuer ?
      </span>
    </div>
    <div
      v-else-if="
        $stores.bookmaker?.state?.bookmakerData?.[
          `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
        ]?.loading
      "
      class="shimmerContainer"
    >
      <div class="text-xl font-bold mb-5">
        Vérification du compte
        {{ $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerName }}
      </div>
      <span class=""> Veuillez patienter </span>
    </div>
    <div v-else>...</div>

    <div
      class="flex gap-4 mt-5 justify-end"
      v-if="
        $stores.bookmaker?.state?.bookmakerData?.[
          `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
        ]?.data
      "
    >
      <button
        class="buttonComponent bg-transparent! border-primary text-primary! border"
        @click="
          $bus.emit($constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE, {
            bookmakerId:
              $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId,
            bookmaker:
              $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker
          })
        "
      >
        Non, changer
      </button>
      <button
        class="buttonComponent bg-primary!"
        @click="
          $bus.emit($constants.EVENTS.BOOKMAKER.BOOKMAKER_ID_CONFIRMED, {
            bookmakerId:
              $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId,
            bookmaker:
              $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker
          })
        "
      >
        Confirmer
      </button>
    </div>
    <div
      class="flex gap-4 mt-5 justify-end"
      v-else-if="
        $stores.bookmaker?.state?.bookmakerData?.[
          `${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker}_${$stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId}`
        ]?.error
      "
    >
      <button class="buttonComponent bg-transparent! border-primary text-primary! border" @click="() => $refs.modal.hide()">
        Retour
      </button>
      <button
        class="buttonComponent bg-primary!"
        @click="
          $bus.emit($constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE, {
            bookmakerId:
              $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmakerId,
            bookmaker:
              $stores.bookmaker?.state?.bookmakerIdConfirmation?.bookmaker
          })
        "
      >
        Changer
      </button>
    </div>
  </DialogComponent>
</template>

